import * as React from 'react';
import { type LucideIcon } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { ModeToggle } from 'components/styles/theme-toggle';

import {
    SidebarGroup,
    SidebarGroupContent,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
} from 'components/ui/sidebar';

export function NavSecondary({
    items,
    ...props
}: {
    items: {
        title: string;
        url: string;
        icon: LucideIcon;
    }[];
} & React.ComponentPropsWithoutRef<typeof SidebarGroup>) {
    const location = useLocation();

    const isActive = (url: string) => {
        return location.pathname.startsWith(url);
    };

    return (
        <SidebarGroup {...props}>
            <SidebarGroupContent>
                <SidebarMenu>
                    <>
                        {items.map((item) => (
                            <SidebarMenuItem key={item.title}>
                                <SidebarMenuButton
                                    asChild
                                    size="sm"
                                    isActive={isActive(item.url)}
                                >
                                    <Link to={item.url}>
                                        <item.icon />
                                        <span>{item.title}</span>
                                    </Link>
                                </SidebarMenuButton>
                            </SidebarMenuItem>
                        ))}
                        <ModeToggle />
                    </>
                </SidebarMenu>
            </SidebarGroupContent>
        </SidebarGroup>
    );
}
